//'Administrador', 'Capturista', 'SignosVitales', 'Triage', 'Doctor'

export const USER_TYPES = [
  {
    text: "Administrador",
    value: "Administrador",
  },
  {
    text: "Capturista",
    value: "Capturista",
  },
  {
    text: "SignosVitales",
    value: "SignosVitales",
  },
  {
    text: "Triage",
    value: "Triage",
  },
  {
    text: "Doctor",
    value: "Doctor",
  },
  {
    text: "AdminSignos",
    value: "AdminSignos",
  },
  {
    text: "AdminTriage",
    value: "AdminTriage",
  },
  {
    text: "AdminEstadisticas",
    value: "AdminEstadisticas",
  }
];
